import { PasswordRecoveryFormErrorJSON } from '../models/password-recovery-form';

export const formPasswordRecoveryErrors: PasswordRecoveryFormErrorJSON = {
    email: [
        {
            code: 'regex',
            message: 'Invalid email',
        },
        {
            code: 'required',
            message: 'Required field',
        },
    ],
};
